export default [
  //  productions  router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "productions",
      layout: "dashboard",
    },
    path: "/productions",
    name: "productions",
    component: () => import("@/layouts/index/ProductionIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Productions",
          layout: "dashboard",
        },
        path: "index",
        name: "productions-index",
        component: () => import("@/views/productions/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Effectué et enregistre la commande",
          layout: "dashboard",
        },
        path: "create",
        name: "productions-create",
        component: () => import("@/views/productions/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Saisir les articles pour réaliser une production",
          layout: "dashboard",
        },
        path: "items/create",
        name: "productions-items-create",
        component: () => import("@/views/productions/items/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Saisir les articles pour réaliser une production",
          layout: "dashboard",
        },
        path: ":reference/items/edit",
        name: "productions-items-edit",
        component: () => import("@/views/productions/items/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails sur la facturation.",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "productions-details",
        component: () => import("@/views/productions/Details.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails sur la facturation.",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "productions-edit",
        component: () => import("@/views/productions/Edit.vue"),
      },
    ],
  },
];
